"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var meterInfo = /** @class */ (function () {
    function meterInfo(props) {
        this.meterId = props.meterId;
        this.deliveryPointId = props.deliveryPointId;
        this.manufacturingYear = props.manufacturingYear;
        this.meterState = props.meterState;
        this.registrationNumber = props.registrationNumber;
        this.meterDiameterCode = props.meterDiameterCode;
        this.meterBrandCode = props.meterBrandCode;
        this.meterModelCode = props.meterModelCode;
        this.serialNumber = props.serialNumber;
        this.meterStatusCode = props.meterStatusCode;
        this.meterPropertyCode = props.meterPropertyCode;
        this.installationDate = props.installationDate;
        this.removalDate = props.removalDate;
        this.calibrationDate = props.calibrationDate;
        this.measureUnitCode = props.measureUnitCode;
        this.pairingStatusCode = props.pairingStatusCode;
        this.lastMeterIndex = props.lastMeterIndex;
        this.trueRegistrationNumber = props.registrationNumber;
        this.numberOfRoller = props.numberOfRoller;
    }
    return meterInfo;
}());
exports.default = meterInfo;
